export default "__VITE_ASSET__p4esNSR___"